module.exports = __webpack_public_path__ + "img/8.7aaf96d7.jpg";